import { render } from "./acctrans-review.vue?vue&type=template&id=59758940&scoped=true"
import script from "./acctrans-review.vue?vue&type=script&lang=js"
export * from "./acctrans-review.vue?vue&type=script&lang=js"

import "./acctrans-review.vue?vue&type=style&index=0&id=59758940&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59758940"]])

export default __exports__